/**
 * @file Button Group Component.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from './Button';

class ButtonGroup extends Component {
  static propTypes = {
    currentValue: PropTypes.any,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
        key: PropTypes.string,
        props: PropTypes.object,
      }),
    ),
    onFilterChange: PropTypes.func,
    buttonProps: PropTypes.object,
    className: PropTypes.string,
  };

  render() {
    const {
      onFilterChange,
      currentValue,
      options,
      buttonProps,
      className,
    } = this.props;

    const classes = classNames({
      'btn-group': true,
      [className]: !!className,
    });

    return (
      <div className={classes}>
        {options.map(option => (
          <Button
            btnOutline={
              typeof option.value === 'function'
                ? option.value(currentValue)
                : option.value !== currentValue
            }
            btnSize="sm"
            key={option.key || option.value}
            className="text-transform-none"
            onClick={
              onFilterChange ? () => onFilterChange(option.value) : undefined
            }
            {...buttonProps}
            {...option.props}
          >
            {option.text}
          </Button>
        ))}
      </div>
    );
  }
}

export default ButtonGroup;
